// extracted by mini-css-extract-plugin
module.exports = {"root":"InsetRow_root__26L65"};